var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main has-footer bg-gray taskCenter"},[_c('top-banner'),_c('task-list',{attrs:{"state":"0","pageSize":"4"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }